export const sortByItems = [
  {
    label: __('Recents'),
    value: 'recents',
  },
  {
    label: __('Votes'),
    value: 'votes',
  },
];
